import React from 'react';
import PropTypes from 'prop-types';
import 'AppSrc/core/style/components/form/modal-options.css';

const modalOptionsShape = PropTypes.shape({
  add: PropTypes.bool,
  saveChanges: PropTypes.bool,
  saveChangesText: PropTypes.string,
  saveChangesTextForValues: PropTypes.func,
  closeModal: PropTypes.func,
  deleteItem: PropTypes.func,
  apply: PropTypes.func,
});


const ModalOptions = React.memo(({
  modalOptions,
  handleSubmit,
  readyToSubmit,
  values,
}) => {
  const {
    back,
    cancel,
    deleteItem,
    apply,
    confirm,
    rightClose,
    confirmClose,
    // NOTE: These params are bool and rely on the handleSubmit function from Formik
    add,
    saveChanges,
    saveChangesText, // overridden text for saveChanges
    saveChangesTextForValues, // function to return save changes text based on the current value
    rejectCrq,
  } = modalOptions;
  const saveChangesDisplayText = saveChangesTextForValues ? saveChangesTextForValues(values) : saveChangesText;
  return (
    <>
      <div className="form-modal-options form-modal-options-spacemaker" />
      <div className="form-modal-options">
        <div className="side-left">
          {
            back && (
              <button
                type="button"
                className="cancel-button"
                onClick={back}
              >
                Back
              </button>
            )
          }
          {
            cancel && (
              <button
                type="button"
                className="cancel-button"
                onClick={cancel}
              >
                Cancel
              </button>
            )
          }
          {
            deleteItem && (
              <button
                type="button"
                className="delete-button"
                onClick={deleteItem}
              >
                Delete
              </button>
            )
          }
        </div>
        <div className="side-right">
          {
            add && (
              <button
                type="button"
                className={`add-button add-button-${readyToSubmit ? 'ready' : 'not-ready'}`}
                onClick={handleSubmit}
              >
                Add
              </button>
            )
          }
          {
            saveChanges && (
              <button
                type="button"
                className={`save-button save-button-${readyToSubmit ? 'ready' : 'not-ready'}`}
                onClick={handleSubmit}
              >
                {saveChangesDisplayText ? saveChangesDisplayText : 'Save'}
              </button>
            )
          }
          {
            rejectCrq && (
              <button
                type="button"
                className={`save-button save-button-${readyToSubmit ? 'ready' : 'not-ready'}`}
                onClick={handleSubmit}
              >
                Reject CRQ
              </button>
            )
          }
          {
            apply && (
              <button
                type="button"
                className="apply-button"
                onClick={apply}
              >
                Apply
              </button>
            )
          }
          {
            confirm && (
              <button
                type="button"
                className={`confirm-button confirm-button-${readyToSubmit ? 'ready' : 'not-ready'}`}
                onClick={confirm}
                disabled={!readyToSubmit}
              >
                Confirm
              </button>
            )
          }
          {
            rightClose && (
              <button
                type="button"
                className="close-button"
                onClick={rightClose}
              >
                Close
              </button>
            )
          }
          {
            confirmClose && (
              <button
                type="button"
                className="close-button"
                onClick={confirmClose}
              >
                Confirm adn close
              </button>
            )
          }
        </div>
      </div>
    </>
  );
});


ModalOptions.propTypes = {
  modalOptions: modalOptionsShape,
  handleSubmit: PropTypes.func,
  readyToSubmit: PropTypes.bool,
  values: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string])),
};

export {
  ModalOptions,
  modalOptionsShape,
};
